/* eslint-disable */

import { HiX } from "react-icons/hi";
import Links from "./components/Links";
import logoSvg from "assets/svg/logo1.svg";

import {
  renderThumb,
  renderTrack,
  renderView,
  renderViewMini,
} from "components/scrollbar/Scrollbar";
import { Scrollbars } from "react-custom-scrollbars-2";
import { routes } from "routes";
import Card from "components/card";
import { useAuth } from "hooks/useAuth";
import Avatar from "components/avatar";

function SidebarHorizon(props) {
  const { open, onClose, variant } = props;
  const { user } = useAuth();

  return (
    <div
      className={`sm:none w-[260px] duration-175 linear fixed !z-50 min-h-full transition-all md:!z-50 lg:!z-50 xl:!z-0 ${
        variant === "auth" ? "xl:hidden" : "xl:block"
      } ${open ? "" : "-translate-x-[105%]"}`}
    >
      <Card
        extra={`ml-3 w-full h-[96.5vh] sm:mr-4 sm:my-4 m-7 !rounded-[20px]`}
      >
        {/* <Scrollbars
          autoHide
          renderTrackVertical={renderTrack}
          renderThumbVertical={renderThumb}
          renderView={renderView}
        > */}
        <div className="flex h-full flex-col justify-between">
          <div>
            <span
              className="absolute top-4 right-4 block cursor-pointer xl:hidden"
              onClick={onClose}
            >
              <HiX />
            </span>
            <div className={`w-full flex items-center px-[30px] mt-[30px]`}>
              <div
                className={`relative font-poppins text-[26px] flex gap-2 items-center font-bold text-navy-700 dark:text-white block`}
              >
                <img className="w-full" src={logoSvg} alt="Atrium" />
                <h3 className="text-gary-700 dark:text-white text-[22px]">
                  Atrium
                </h3>
                {/* <p className="text-[10px] text-center font-normal absolute left-9 w-full capitalize">Manage Church Admin</p> */}
              </div>
            </div>
            <div className="mt-[18px] mb-7 h-px bg-gray-200 dark:bg-white/10" />
            {/* Nav item */}
            <ul className="flex flex-col gap-3">
              <Links routes={routes} />
            </ul>
          </div>

          <div className="mt-[28px] mb-[30px] px-[30px]">
            <div className="mt-5 flex items-center  gap-3">
              <div className="h-12 w-12 rounded-full shrink-0">
                <Avatar user={user} size="md" />
              </div>
              <div className={`ml-1 "block"`}>
                <h4 className="text-base font-bold text-navy-700 dark:text-white">
                  {user?.firstName} {user?.lastName}
                </h4>
                <p className="text-sm font-medium text-gray-600 capitalize">
                  {user?.role}
                </p>
              </div>
            </div>
          </div>
        </div>
        {/* </Scrollbars> */}
      </Card>
    </div>
  );
}

export default SidebarHorizon;
